export function phoneValidate(phone: string) {
  return phone.replaceAll(/[()_ -]/g, '').length === 11
}
